import { createSlice } from '@reduxjs/toolkit';

const EquipmentDetailsDataSlice = createSlice({
    name: 'EquipmentDetailsData',
    initialState: '',
    reducers: {
        setEquipmentDetailsData: (state, action) => {
            return action.payload;
        },
        resetEquipmentDetailsData: (state) => {
            return null;
        },
    },
});

export const { setEquipmentDetailsData, resetEquipmentDetailsData } = EquipmentDetailsDataSlice.actions;
export default EquipmentDetailsDataSlice.reducer;